"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _all = require("animations-json/build/all");

var _LottieAnimationBase = _interopRequireDefault(require("../LottieAnimationBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Animation62 = /*#__PURE__*/function (_AnimationBase) {
  _inherits(Animation62, _AnimationBase);

  var _super = _createSuper(Animation62);

  function Animation62(animObj) {
    var _this;

    _classCallCheck(this, Animation62);

    var animationId = animObj.animationId;
    var data = animObj.data;
    var config = {
      default: {
        colors: ['#FA3F00', '#F9D3D9']
      },
      maxCharInline: 1000,
      minLines: 1,
      maxLines: 6,
      lineHeight: {
        base: 100,
        extra: 50
      },
      width: 1280,
      height: 720,
      textShadow: false,
      inDuration: 560,
      intermissionDuration: 3000,
      outDuration: 560,
      totalDuration: 4120,
      isStatic: true
    };
    _this = _super.call(this, animObj, data, config);
    var animation = (0, _all.getAnimationJson)(animationId); // set colors
    // replace with color 1

    var fonColorPattern1 = new RegExp('"fc":\\[0.98,0.247,0]', 'g');
    var fonColorPattern2 = new RegExp('"fc":\\[0.976,0.827,0.851]', 'g');
    var shapeColorPattern1 = new RegExp('\\[0.976470588235,0.827450980392,0.850980392157,1]', 'g');
    var shapeColorPattern2 = new RegExp('\\[0.980391979218,0.247455000877,0,1]', 'g');
    animation = animation.replace(fonColorPattern1, "\"fc\":[".concat(_this.colors[0], "]")).replace(fonColorPattern2, "\"fc\":[".concat(_this.colors[1], "]")).replace(shapeColorPattern1, "[".concat(_this.colors[1], "]")).replace(shapeColorPattern2, "[".concat(_this.colors[0], "]")); // replace place holders with the line value

    var cloneLines = _toConsumableArray(_this.lines);

    switch (_this.lines.length) {
      case 2:
        cloneLines[3] = _this.lines[1];
        cloneLines[1] = '';
        cloneLines[2] = '';
        break;

      case 3:
        cloneLines[3] = _this.lines[2];
        cloneLines[2] = '';
        break;

      case 4:
        cloneLines[4] = _this.lines[3];
        cloneLines[3] = _this.lines[2];
        cloneLines[2] = '';
        break;

      default:
    }

    for (var i = 0; i < config.maxLines; i++) {
      var line = cloneLines.length > i ? cloneLines[i] : '';
      var regx = new RegExp("{#DYNAMICINPUT_0".concat(i + 1, "#}"), 'g');
      animation = animation.replace(regx, line);
    } // update fonts list for this animation


    if (!_this.fonts || _this.fonts.length === 0) {
      _this.fonts = [{
        font: 'Anton',
        weight: 400
      }];
    } // parse string to object


    var json = JSON.parse(animation);
    _this.height = json.h;
    _this.width = json.w;
    _this.json = json;
    return _this;
  }

  return Animation62;
}(_LottieAnimationBase.default);

exports.default = Animation62;